import styled from '@emotion/styled'
import DatePicker from 'antd/lib/date-picker'

export const StyledDatePicker = styled(DatePicker)`
  .ant-picker-input {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    width: 100%;

    .ant-picker-suffix {
      margin-right: 5px;
    }
  }
`
